// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectFilledSvg from "@fishx/icons-svg/es/asn/MoneyCollectFilled";
import FishxIcon from '../components/FishxIcon';

var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectFilledSvg
  }));
};

MoneyCollectFilled.displayName = 'MoneyCollectFilled';
export default React.forwardRef(MoneyCollectFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MoneyCollectFilled.js
// module id = 3153
// module chunks = 0